// Convención Wipxap de labels semánticos. Los labels viven en GitHub (gestionados
// vía script desde el repo), WipHub solo los aplica/lee.

import type { Issue } from './github'

export type IssueType = 'bug' | 'feature' | 'idea' | 'chore' | 'refactor' | 'docs'

export const ALL_TYPES: readonly IssueType[] = ['bug', 'feature', 'idea', 'chore', 'refactor', 'docs'] as const

export const TYPE_TAILWIND: Record<IssueType, string> = {
  bug:      'bg-red-500 text-white',
  feature:  'bg-emerald-500 text-white',
  idea:     'bg-violet-500 text-white',
  chore:    'bg-zinc-500 text-white',
  refactor: 'bg-sky-500 text-white',
  docs:     'bg-blue-500 text-white',
}

const TYPE_SET: Set<string> = new Set(ALL_TYPES)

// Heurísticas para sugerir el tipo cuando el issue NO tiene label de tipo.
const BUG_WORDS = /\b(bug|error|fail|falla|broken|crash|roto|no funciona|deja de|incorrecto|wrong)\b/i
const FEAT_WORDS = /\b(feat|feature|add|agregar|nuevo|implementar|soporte para|crear)\b/i
const IDEA_WORDS = /\b(idea|qué tal si|podríamos|deberíamos|considerar|explorar)\b/i
const CHORE_WORDS = /\b(chore|bump|deps|dependencies|config|infra)\b/i
const REFACTOR_WORDS = /\b(refactor|reorganizar|cleanup|limpiar)\b/i
const DOCS_WORDS = /\b(docs|documentation|readme|comentar)\b/i

// Si el issue ya tiene alguno de los labels semánticos, retorna ese tipo.
export function currentType(issue: Issue): IssueType | null {
  for (const l of issue.labels) {
    const name = l.name.toLowerCase()
    if (TYPE_SET.has(name)) return name as IssueType
  }
  return null
}

// Sugiere el tipo basado en título/labels existentes. Default: bug.
export function suggestType(issue: Issue): IssueType {
  // Si tiene un label semántico existente, respetarlo (no reasignar).
  const existing = currentType(issue)
  if (existing) return existing

  // Si tiene label `enhancement` de GitHub default, traducir a feature.
  for (const l of issue.labels) {
    if (l.name.toLowerCase() === 'enhancement') return 'feature'
  }

  if (DOCS_WORDS.test(issue.title)) return 'docs'
  if (CHORE_WORDS.test(issue.title)) return 'chore'
  if (REFACTOR_WORDS.test(issue.title)) return 'refactor'
  if (IDEA_WORDS.test(issue.title)) return 'idea'
  if (FEAT_WORDS.test(issue.title)) return 'feature'
  if (BUG_WORDS.test(issue.title)) return 'bug'
  return 'bug'
}
